var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.905,
    height: 23.227,
    viewBox: "0 0 20.905 23.227",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Document",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Document-2",
    "data-name": "Document",
    d: "M15.32,23.227H5.586C2.036,23.227,0,21.178,0,17.606v-12A5.7,5.7,0,0,1,1.469,1.477,5.648,5.648,0,0,1,5.586,0H15.32C18.869,0,20.9,2.045,20.9,5.61v12a5.68,5.68,0,0,1-1.447,4.161A5.6,5.6,0,0,1,15.32,23.227ZM5.805,15.953a.906.906,0,0,0-.776.434.913.913,0,0,0,.758,1.4.813.813,0,0,0,.113-.007h9.106a.918.918,0,0,0,0-1.823H5.9A.929.929,0,0,0,5.805,15.953ZM5.9,10.66a.906.906,0,0,0,0,1.812h9.106a.906.906,0,0,0,0-1.812Zm0-5.26v.011h0a.905.905,0,0,0,0,1.81H9.372a.911.911,0,0,0,0-1.823Z",
    transform: "translate(0 0)",
    fill: "#191919"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentShow);
export default __webpack_public_path__ + "static/media/DocumentShow.1e2f876c6b13fc55afc31549f411dd2c.svg";
export { ForwardRef as ReactComponent };